module.exports = __webpack_public_path__ + "r-v3/img/arrow-down_white.29ec904a.svg";